import productModule from '@js/store/modules/product';
import stockModule from '@js/store/modules/stock';

export default {
    beforeCreate() {
        if (!this.$store.hasModule('product')) {
            this.$store.registerModule('product', productModule);
        }

        if (!this.$store.hasModule('stock')) {
            this.$store.registerModule('stock', stockModule);
        }
    },

    methods: {
        /**
         * clear function is not working for custom added scope from backend
         * has to remove manually
         **/
        clearAllBackEndErrorScope() {
            this.variants.forEach((v, idx) => {
                const scopeSku = `variants.${idx}.sku`;
                const scopeBarcode = `variants.${idx}.barcode`;

                this.errors.clear(scopeSku);
                this.errors.clear(scopeBarcode);
            });
        },
    },
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/product-mixins.js